module.exports = __webpack_public_path__ + "images/disability.02c3f731777b175db7f2e475441760ef.svg";